import React from 'react';
import classnames from 'classnames';
import Socials from 'components/Elements/Socials';
import * as styles from './socialsContainer.module.scss';

const SocialsContainer = ({ DataSocials, socials }) => {
  return (
    <div className={classnames(styles.socials)}>
      <p className={classnames(styles.textWrap, 'cr-reg')}>
        <span className={classnames(styles.title)}>{socials.title}</span> &#160;
        <span className={classnames(styles.subtitle)}>{socials.subtitle}</span>
      </p>

      <Socials socials={DataSocials} />
    </div>
  );
};

export default SocialsContainer;
